import { render, staticRenderFns } from "./customer-case.vue?vue&type=template&id=3b1e1bde&scoped=true"
import script from "./customer-case.vue?vue&type=script&lang=js"
export * from "./customer-case.vue?vue&type=script&lang=js"
import style0 from "./customer-case.vue?vue&type=style&index=0&id=3b1e1bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e1bde",
  null
  
)

export default component.exports